import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setSilosAssignmentGrid = (state, { siloAssignmentGrid }) => {
  if (!siloAssignmentGrid) return state;
  return state.merge({ siloAssignmentGrid });
};

const setAllocatedRawMaterial = (state, { materialAllocations }) => {
  if (!materialAllocations) return state;
  return state.merge({ materialAllocations });
};

const setSearchAllocatedRawMaterial = (state, { allocatedMaterials }) => {
  if (!allocatedMaterials) return state;
  return state.merge({ allocatedMaterials });
};

const setMaterialConsumption = (state, { materialConsumptions }) => {
  if (!materialConsumptions) return state;
  return state.merge({ materialConsumptions });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_SILOS_ASSIGNMENT_GRID,
    actionFunction: setSilosAssignmentGrid,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_ALLOCATED_RAW_MATERIAL,
    actionFunction: setAllocatedRawMaterial,
  },
  {
    actionType: ActionTypes.SET_SEARCH_ALLOCATED_RAW_MATERIAL,
    actionFunction: setSearchAllocatedRawMaterial,
  },
  {
    actionType: ActionTypes.SET_MATERIAL_CONSUMPTION,
    actionFunction: setMaterialConsumption,
  },
];
